import { Injectable } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';
import { IReport } from '@interfaces/index';
import { ReportRenderService, reportPdfFilename } from '@ui-components/report';
import { ReportService } from './report.service';

@Injectable({
  providedIn: 'root',
})
export class ReportDownloadService {

  constructor(
    private _report_service: ReportService,
    private _report_render_service: ReportRenderService
  ) {}

  downloadReport(orgPersonAssessmentId: number): Observable<void> {
    return this._report_service.getReport(orgPersonAssessmentId).pipe(
      map((response) => response.data as IReport),
      switchMap((report) => this._report_render_service.renderToHtml(report).pipe(
        switchMap((html) => this._report_service.downloadReport(html)),
        map((blob) => ({ blob, report }))
      )),
      map(({ blob, report }) => this._saveBlob(blob, reportPdfFilename(report)))
    );
  }

  private _saveBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  }
}
